import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnDestroy,
} from "@angular/core";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { CatExpertRouterLink } from "../../app-routing-enum";
import { StateService } from "../../services/state.service";
import { filter } from "rxjs/operators";
import { Subscription } from "rxjs";

@Component({
  selector: "app-common-sidebar",
  templateUrl: "./common-sidebar.component.html",
  styleUrl: "./common-sidebar.component.scss",
})
export class CommonSidebarComponent implements OnInit, OnDestroy {
  @Input() commonMenuItems: any[] = [];
  @Output() actionCollapseSidebar = new EventEmitter<any>();
  activeRoute!: string;
  sidebarCollapse: boolean = false;
  hoveredIndex: number | null = null;
  private routerSubscription!: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public stateService: StateService
  ) {}

  ngOnInit(): void {
    // Set initial active route
    this.updateActiveRoute();

    // Subscribe to router events to update active route on navigation
    this.routerSubscription = this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe(() => {
        this.updateActiveRoute();
      });
  }

  ngOnDestroy(): void {
    // Clean up subscription
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private updateActiveRoute(): void {
    this.activeRoute =
      this.stateService.getActiveRouteSegment() ?? CatExpertRouterLink.Studio;
  }

  navigateToRouter(slug: string) {
    // Remove leading slash if present to normalize the slug
    const normalizedSlug = slug.startsWith("/") ? slug.substring(1) : slug;

    // Get keyAccountId from current route params
    let keyAccountId: string | null = null;

    // Traverse the route tree to find keyAccountId parameter
    let currentRoute = this.route;
    while (currentRoute) {
      if (currentRoute.snapshot.paramMap.has("keyAccountId")) {
        keyAccountId = currentRoute.snapshot.paramMap.get("keyAccountId");
        break;
      }
      currentRoute = currentRoute.firstChild as any;
    }

    // Get current URL without query params
    const currentUrl = this.router.url.split("?")[0];

    // Build target URL with keyAccountId if present
    let targetUrl = `/${CatExpertRouterLink.Studio}/${normalizedSlug}`;

    // If keyAccountId exists, append it to the URL
    if (
      keyAccountId &&
      !targetUrl.includes(`/${CatExpertRouterLink.SyncSKU}`)
    ) {
      targetUrl = `/${CatExpertRouterLink.Studio}/${normalizedSlug}/${CatExpertRouterLink.KA}/${keyAccountId}`;
    }

    // Don't navigate if already on the target route
    if (currentUrl === targetUrl) return;

    this.router.navigate([targetUrl]);
  }

  checkSidebarActive() {
    this.sidebarCollapse = !this.sidebarCollapse;
    this.actionCollapseSidebar.emit(this.sidebarCollapse);
  }
}
